<form [formGroup]="form" [waiting]="loadingService.isLoading(this)">


  <div class="row">
    <div class="col grow">
      <div class="row">
        <div class="grow">
          <icz-form-autocomplete  class="grow" label="Křížový odkaz" formControlName="name" [options]="templateOptions"></icz-form-autocomplete>
          <icz-form-autocomplete class="grow" label="Prohledávat pouze některé objekty" formControlName="entityType" [options]="entityTypeOptions$ | async"></icz-form-autocomplete>
        </div>
        <div class="grow"></div>
      </div>

      @let excludeObjectsWithId = [this.modalData.entityId];

      @if (allowableEntityTypes.length === 0) {
        <icz-form-field label="Vyhledat objekt" [fieldDisabled]="true"></icz-form-field>
      }
      @else if (allowableEntityTypes.length === 2) {
        <icz-document-or-file-selector
          label="Vyhledat objekt"
          [form]="form"
          controlName="entitiesReferringTo"
          [isMultiselect]="true"
          [excludeObjectsWithId]="excludeObjectsWithId"
          (objectsSelected)="objectsSelected($event)"
        ></icz-document-or-file-selector>
      }
      @else if (allowableEntityTypes[0] === EntityType.DOCUMENT) {
        <icz-document-selector
          label="Vyhledat objekt"
          [form]="form"
          controlName="entitiesReferringTo"
          [isMultiselect]="true"
          [excludeObjectsWithId]="excludeObjectsWithId"
          (objectsSelected)="objectsSelected($event)"
        ></icz-document-selector>
      }
      @else if (allowableEntityTypes[0] === EntityType.FILE) {
        <icz-file-selector
          label="Vyhledat objekt"
          [form]="form"
          controlName="entitiesReferringTo"
          [isMultiselect]="true"
          [excludeObjectsWithId]="excludeObjectsWithId"
          (objectsSelected)="objectsSelected($event)"
        ></icz-file-selector>
      }
      @else {
        <icz-not-implemented></icz-not-implemented>
      }
    </div>
  </div>
</form>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit
              [disabled]="loadingService.isLoading(this)"
              (onAction)="submit()"
              primary label="Přidat odkaz na objekt"
  ></icz-button>
  <icz-button rightButtons
              [disabled]="loadingService.isLoading(this)"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
